exports.components = {
  "component---packages-gatsby-theme-docs-src-templates-homepage-js": () => import("./../../../../../packages/gatsby-theme-docs/src/templates/homepage.js" /* webpackChunkName: "component---packages-gatsby-theme-docs-src-templates-homepage-js" */),
  "component---packages-gatsby-theme-docs-src-templates-page-content-js": () => import("./../../../../../packages/gatsby-theme-docs/src/templates/page-content.js" /* webpackChunkName: "component---packages-gatsby-theme-docs-src-templates-page-content-js" */)
}

